import { RadioTower, MousePointer2, MessageSquareText, Trophy, Layers, Link2 } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';

const FEATURES = [
  {
    icon: RadioTower,
    title: 'Real-Time Editing',
    body: 'Everyone edits the same note at once. Changes appear live, character by character — no refresh, no version conflicts, no "final_v2_FINAL".',
  },
  {
    icon: MousePointer2,
    title: 'Live Cursors & Presence',
    body: "Watch your classmates' cursors glide across the page in their own colour. You always know who's reading and editing what, right now.",
  },
  {
    icon: MessageSquareText,
    title: 'Comments & Highlights',
    body: 'Drop a comment on any line, highlight a tricky passage, or ask a question in the margin. Threads keep every discussion in context.',
  },
  {
    icon: Trophy,
    title: 'Live Group Quizzes',
    body: 'Launch a quiz from your shared notes and compete on a real-time leaderboard. Studying together, made a little competitive.',
  },
  {
    icon: Layers,
    title: 'Shared Flashcards',
    body: 'Build a deck as a team and everyone studies from it. Split the workload and master the whole syllabus faster together.',
  },
  {
    icon: Link2,
    title: 'One-Link Sharing',
    body: 'Invite your whole group with a single link. No accounts to chase, no files to email — just click and you\'re in the room.',
  },
];

const CollabFeatures = () => {
  return (
    <section className="relative py-20 lg:py-24">
      <div className="glow left-1/2 top-0 h-[360px] w-[600px] -translate-x-1/2 bg-accent/8" />
      <Container className="relative">
        <Reveal className="text-center">
          <span className="eyebrow">Collaboration Features</span>
          <h2 className="font-heading mx-auto mt-5 max-w-3xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
            <span className="head-fade">Everything You Need To </span>
            <span className="text-accent-grad">Study As One</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[0.95rem] text-white/55">
            A real-time workspace built for students — not a document editor with
            studying bolted on.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 3) * 90}>
              <div className="glass glass-hover h-full rounded-2xl p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/12 text-accent">
                  <f.icon size={21} />
                </span>
                <h3 className="font-heading mt-5 text-[1.1rem] font-semibold text-white">
                  {f.title}
                </h3>
                <p className="mt-2 text-[0.87rem] leading-relaxed text-white/55">
                  {f.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default CollabFeatures;
